import Vue from "vue";
import * as VueGoogleMaps from 'vue2-google-maps';
import Swiper, {Autoplay} from "swiper";

Swiper.use([Autoplay]);

const files = require.context("./", true, /\.vue$/i);
files.keys().map((key) =>
    Vue.component(
        key
            .split("/")
            .pop()
            .split(".")[0],
        files(key).default,
    ),
);

Vue.use(VueGoogleMaps, {
    load: {
        key: process.env.MIX_GOOGLE_MAPS_JS_API_TOKEN,
        libraries: 'places',
    },
});

const app = new Vue({
    el: "#app",
});

var swiper = new Swiper(".swiper-container", {
    slidesPerView: 1,
    spaceBetween: 30,
    loop: true,
    rtl: false,
    freeMode: true,
    centeredSlided: true,
    autoplay: {
        delay: 2500,
        disableOnInteraction: false,
    },
    breakpoints: {
        640: {
            slidesPerView: 3,
        },
        1024: {
            slidesPerView: 4,
        },
        1280: {
            slidesPerView: 5,
        },
        1536: {
            slidesPerView: 7,
        },
    },
});
